import "./bootstrap"
import { createApp } from "vue"
import { createRouter, createWebHistory } from "vue-router"
import AuthApp from "./auth/AuthApp.vue"
import Registration from "./auth/scenes/Registration.vue"
import * as Sentry from "@sentry/vue"

const routes = [
  {
    path: "/register",
    component: Registration,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
})

// Mount the app
const app = createApp(AuthApp)

Sentry.init({
  app,
  dsn: window.keys.sentry_dsn,
  sendDefaultPii: true,
  // This enables automatic instrumentation (highly recommended),
  // but is not necessary for purely manual usage
  integrations: [Sentry.browserTracingIntegration()],

  //Update tracesSampleRate to 0.1 for production
  tracesSampleRate: window.keys.sentry_sample_rate,

  tracePropagationTargets: window.keys.sentry_propagation ? window.keys.sentry_propagation.split(",") : [],
})

// Configure the app
app.config.compilerOptions.isCustomElement = (tag) => tag === "ion-icon"

// Use router
app.use(router)

// Mount the app
app.mount("#app")
